import { CurtainsIcon } from './CurtainsIcon';

/**
 * author: Teodor Sandu
 * id 8C3A8BC3-9144-4D24-A41D-BBE2B557BF51
 * name curtains
 * version: 6.2.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/curtains.svg
 * tags
 * - Home Automation 
 */
export const DrapesIcon = CurtainsIcon;
export default DrapesIcon